import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useAppContext } from './contexts/AppContext';
import SideBar from './components/SideBar';
import TopBar from './components/TopBar';
import DesktopHeader from './components/DesktopHeader';
import BottomNav from './components/BottomNav';
import Dashboard from './pages/Dashboard';
import Vehicles from './pages/Vehicles';
import TemporaryVehicles from './pages/TemporaryVehicles';
import Documents from './pages/Documents';
import Companies from './pages/Companies';
import Alerts from './pages/Alerts';
import Events from './pages/Events';
import Accidents from './pages/Accidents';
import Costs from './pages/Costs';
import Leasing from './pages/Leasing';
import Drivers from './pages/Drivers';
import ActivityLog from './pages/ActivityLog';
import Suppliers from './pages/Suppliers';
import Login from './pages/Login';
import DriverLogin from './pages/DriverLogin';
import DriverShell from './components/DriverShell';
import { initPushNotifications } from './services/pushNotifications';
import './styles/index.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAppContext();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function AppShell() {
  const { pageResetKey } = useAppContext();
  // No-op on the web; in the Android app this registers the device so admins
  // receive the daily critical-documents push as well.
  useEffect(() => { initPushNotifications().catch(() => {}); }, []);
  return (
    <div id="app">
      <SideBar />
      <div className="desktop-main">
        <TopBar />
        <DesktopHeader />
        <main className="content">
          <Routes key={pageResetKey}>
            <Route path="/"          element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/vehicles"  element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
            <Route path="/vehicles/temporary" element={<ProtectedRoute><TemporaryVehicles /></ProtectedRoute>} />
            <Route path="/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
            <Route path="/companies" element={<ProtectedRoute><Companies /></ProtectedRoute>} />
            <Route path="/alerts"    element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
            <Route path="/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
            <Route path="/events"    element={<ProtectedRoute><Events /></ProtectedRoute>} />
            <Route path="/accidents" element={<ProtectedRoute><Accidents /></ProtectedRoute>} />
            <Route path="/costs"     element={<ProtectedRoute><Costs /></ProtectedRoute>} />
            <Route path="/leasing"   element={<ProtectedRoute><Leasing /></ProtectedRoute>} />
            <Route path="/drivers"   element={<ProtectedRoute><Drivers /></ProtectedRoute>} />
            <Route path="/log"       element={<ProtectedRoute><ActivityLog /></ProtectedRoute>} />
          </Routes>
        </main>
        <BottomNav />
      </div>
    </div>
  );
}

function AppRoutes() {
  const { isAuthenticated, role, authReady } = useAppContext();
  if (!authReady) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f0f2f5' }} />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/driver-login" element={<DriverLogin />} />
      <Route path="/*" element={
        !isAuthenticated
          ? <Navigate to="/login" replace />
          : role === 'driver'
            ? <DriverShell />
            : <AppShell />
      } />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AppProvider>
  );
}

export default App;
